import { Outlet } from "react-router-dom";
import Navigation from "../Navigation";
import Footer from "../Footer";
import "./index.scss";
import TopNavAlert from "../TopNavAlert";

const Layout = () => {
  return (
    <div className="App">
      <TopNavAlert />
      <Navigation />
      <div className="page">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
